import React from 'react';
import AbsenceAdmin from '../../../components/absence/ManageAbsencesAdmin/ManageAbsencesAdmin';

const ManageAbsencesAdmin = () => {
    return (
        <AbsenceAdmin />
        
    )
}


export default ManageAbsencesAdmin;